import React, { useEffect } from 'react';
import { PortfolioHeader } from '../components/PortfolioHeader';
import { ExpertiseRadar } from '../components/RadarChart';
import { CompetencyGrid } from '../components/CompetencyGrid';
import { CareerTimeline } from '../components/CareerTimeline';
import { Certifications } from '../components/Certifications';
export function Portfolio() {
  useEffect(() => {
    document.title = 'Portfolio - Aditya Khurana';
  }, []);
  return <div className="min-h-screen bg-background text-foreground font-sans" data-id="element-110">
      <PortfolioHeader data-id="element-111" />

      <main className="container mx-auto px-4 py-16 space-y-24" data-id="element-112">
        {/* Career Journey Section */}
        <section className="max-w-5xl mx-auto" data-id="element-113">
          <div className="text-center mb-16" data-id="element-114">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-115">
              Career Journey
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto text-lg" data-id="element-116">
              My professional evolution from hands-on security engineering to
              strategic product leadership.
            </p>
          </div>
          <CareerTimeline data-id="element-117" />
        </section>

        {/* Expertise Visualization Section */}
        <section className="max-w-4xl mx-auto" data-id="element-118">
          <div className="text-center mb-10" data-id="element-119">
            <h2 className="text-3xl font-bold mb-4" data-id="element-120">Expertise Overview</h2>
            <p className="text-muted-foreground" data-id="element-121">
              A balanced mix of offensive security, defensive strategy, and
              product leadership.
            </p>
          </div>
          <div className="bg-card rounded-xl border shadow-sm p-6 md:p-10" data-id="element-122">
            <ExpertiseRadar data-id="element-123" />
          </div>
        </section>

        {/* Certifications Section */}
        <section className="max-w-5xl mx-auto" data-id="element-124">
          <div className="text-center mb-12" data-id="element-125">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-126">
              Certifications
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto text-lg" data-id="element-127">
              Professional credentials and continuous learning achievements.
            </p>
          </div>
          <Certifications data-id="element-128" />
        </section>

        {/* Core Competencies Grid Section */}
        <section className="max-w-5xl mx-auto" data-id="element-129">
          <div className="text-center mb-12" data-id="element-130">
            <h2 className="text-3xl font-bold mb-4" data-id="element-131">Core Competencies</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto" data-id="element-132">
              Deep dive into my technical capabilities and strategic
              achievements. Click on any card to explore projects, tools, and
              results.
            </p>
          </div>
          <CompetencyGrid data-id="element-133" />
        </section>

        {/* Footer */}
        <footer className="text-center text-sm text-muted-foreground pt-10 border-t" data-id="element-134">
          <p data-id="element-135">
            © {new Date().getFullYear()} Aditya Khurana. Built with React &
            Tailwind CSS.
          </p>
        </footer>
      </main>
    </div>;
}